import { Component, Input, OnInit } from '@angular/core';
import { Subscription, timer } from 'rxjs';
import { ProgressSpinnerMode } from '@angular/material/progress-spinner';
import { ApiExportsService } from 'src/app/service/api-exports.service';
import { environment } from 'src/environments/environment';
import { FormGroup } from '@angular/forms';
import { UrlProviderService } from 'src/app/service/urlprovider.service';
import { ProgressSpinnerSet, UtilityService } from 'src/app/service/utility.service';
import { ApiFetchExportDataService } from 'src/app/service/api-fetchexportdata.service';
import { Router } from '@angular/router';
import { ChildReportsService } from '../../child-reports/service/child-reports.service';
import { ThemePalette } from '@angular/material/core';
import { QuestionHelpTextService } from 'src/app/service/question-help-text.service';
import { PagingService } from 'src/app/service/paging.service';
//import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { HelpTextComponent } from '../help-text/help-text.component';
import { QuestionHelpText } from 'src/app/model/question-help-text';
import { InaSchoolEnrollment } from '../../children/edit-child/ina/model/ina-school-enrollment';
import { MsgModel } from '../msg/model/msg.model';

@Component({
  selector: 'app-exportbtn',
  templateUrl: './exportbtn.component.html',
  styleUrls: ['./exportbtn.component.scss']
})
export class ExportbtnComponent implements OnInit {
    @Input() searchParm: any = [{}];

    ina: any = null;
    studentId: string = ""; 
    @Input() ngDisabled: boolean = false;
    @Input() lstData: InaSchoolEnrollment[];

    isExporting: boolean = false;
    hasExports: boolean = false;
    progressCurrentValue: number = 10;
    progressValue: number = 10;
    progressMax: number = 200;
    progressSpinnerMax: number = 100;
    progressColor: ThemePalette = 'accent';    
    progressType: ProgressSpinnerMode = 'determinate';    
    progressSpeed: number = 50;  
    progressSubscription: Subscription;
    progressInterval: number = 500;
    strExportFileName = "PFS_Report";
    fileNameLabel: string = "";
    bCheckedStyling: boolean = true;
    
     // Help Text
    questionIds: number[] = [259];

    lstQuestionHelpText: QuestionHelpText[] = [];
    currentSetting: any;
    isLoadingResults: boolean = false;    
    isLoading: boolean = false;
    msg: MsgModel = {};

    lstExportDataResponse: InaSchoolEnrollment[];
    
	settings: any = {
        '/children': {
            TITLE: 'INA View',
            EXPORTFILENAME: 'INA_View',
            API: undefined,
            SCHOOL_YEAR: true,
            QUESTION_HELP_TEXT_ID: 248,
            COLUMN_HEADERS: [
                'School Year',
                'Region',
                'District',
                'School',
                'MSD Number',
                'SSID',
                'Name',
                'Grade',
                'QAD'
                                                 
            ],
            COLUMN_WIDTHS: [
                52,
                52,
                52,
                82,
                82,
                52,
                52,
                52,
                52                                        
            ],
            COLUMNS: [
            	'SCHOOL_YEAR',
            	'REGION',
            	'DISTRICT',
            	'SCHOOL',
            	'MSD_NUMBER', 
            	'SSID', 
            	'PERSON.LAST_NAME', 
            	'GRADES', 
            	'QAD'               
            ]
        }
    }

    constructor( public questionHelpTextService: QuestionHelpTextService,
        public pagingService: PagingService,
        private apiMsinExportsService: ApiExportsService,
        private urlProvider: UrlProviderService,        
        private utilityService: UtilityService,
        private apiFetchExportDataService: ApiFetchExportDataService,
        router: Router,
        private childReportsService: ChildReportsService) { 
		    	console.log("now connecting:")
	        console.log(router.url);
	        //this.connectAPIs(childReportsService);
	        //this.selectSettings(router.url);
	        //console.log("currentSetting:")
	        //console.log(this.currentSetting)
	        //console.log(this.settings)
	        this.invokeHelpTextAPI();

    }

    ngOnInit(): void {
   /*   setTimeout(() => {
        this.ngDisabled = true;
        console.log('ngDisabled set to :', this.ngDisabled);
      }, 5000); */
    }
    
    generatePayload(): any {
        let payload: any = {};

        
        payload.performancePeriod = "2025-27";


        return payload;
    }
    
    connectAPIs(  childReportsService: ChildReportsService) {
        this.settings['/children'].API = function (payload: any) {
            return childReportsService.getINAView(payload);
        };
    }

    selectSettings(url: string) {

        this.currentSetting = this.settings[url];

    }


    exportPdf(inputOpt? : string) {
      console.log("now generating pdf export from common component exportbtn")
      if (inputOpt != null)
      {
        console.log("with inputs")
      }
		  this.downloadPdfCore();
	}

	downloadPdfCore()
    {
              console.log('now downstreaming PDF file');
      
              this.lstExportDataResponse = this.lstData;              
              console.log("with rows:")
              console.log(this.lstExportDataResponse )
              this.isExporting = true;
              this.progressMax = this.lstExportDataResponse.length;
              console.log("set progressMax at:")
              console.log(this.progressMax)

              this.progressValue = 10;
              this.progressCurrentValue = 10;
              this.progressValue = (1/this.progressMax)*100;
      
              console.log("initial progressValue=")
              console.log(this.progressValue)
              
               this.searchParm.bCheckedStyling = this.bCheckedStyling.toString(); 
              this.strExportFileName = this.currentSetting?.EXPORTFILENAME ?? "";
              let strTemplateName = this.strExportFileName; 
              this.searchParm.strExportType = 'PDF'
      
      
              try
              {

                this.lstExportDataResponse =  this.lstData;
            
                this.searchParm = this.generatePayload();
            
                this.searchParm.Template_Name = strTemplateName;
            
                this.searchParm.strFileName = strTemplateName; 
                this.searchParm.fileNameLabel = this.fileNameLabel;
                this.searchParm.bCheckedStyling = this.bCheckedStyling.toString();  

                this.searchParm.columns = this.currentSetting?.COLUMNS;
                this.searchParm.columnHeaders = this.currentSetting?.COLUMN_HEADERS ?? 0;
                this.searchParm.columnWidths = this.currentSetting?.COLUMN_WIDTHS ?? 0;
                this.searchParm.file_name_label = this.currentSetting?.TITLE ?? "";
                this.searchParm.reportType = 1;
                this.searchParm.strExportType = "PDF";

                setTimeout(
                    ()=>{
                        console.log("passing searchParm")
                        console.log(this.searchParm)
                        this.isExporting = true;  
                        const progressInterval = setInterval(()=>{
                            if (this.progressCurrentValue <= this.progressSpinnerMax) // this corresponds to 100% of the spinner rotation
                            {
                                this.progressCurrentValue+=1;
                                this.progressValue = (this.progressCurrentValue/this.progressMax) * 100;
                            /* console.log("cur value is: ")
                                console.log(this.progressValue)
                                console.log(this.progressCurrentValue)*/

                            }
                            else
                            {                            
                                this.isExporting = false;
                                clearInterval(progressInterval);
                            }

                        }, this.progressSpeed); // spinner speed, smaller value=faster
                        
                     
                            
                        var params = {
	                       
	                        performancePeriod: this.searchParm.schoolYear,
	                        /*expiredEligibility: this.expiredEligibility,
	                        expiredQAD: this.expiredQAD,
	                        grades: this.grades,
	                        partyServices: this.partyServices,
	                        enrollmentPeriods: this.enrollmentPeriods*/
	                        
                        }    
                     
                        this.searchParm.performancePeriod = params.performancePeriod;
                        console.log("now calling http post with params:")
                        console.log(params)
           				  this.apiMsinExportsService.getINAViewPost(this.searchParm);
                    }
                );   
              }
              catch (Err)
              {
                console.log("Error running filestream PDF export: ")
                console.log(Err);	
				//console.log("hid spinner2")
                this.isExporting = false;  
            }  
    }
    
    // Help Text
    invokeHelpTextAPI() {
        this.questionHelpTextService.getHelpText(this.questionIds).subscribe((lstQuestionHelpText: QuestionHelpText[]) => {
            this.lstQuestionHelpText = lstQuestionHelpText;
        });
    }

    displayHelpText(qId: number) {
      /*  const dialogConfig = new MatDialogConfig();
        dialogConfig.autoFocus = true;
        dialogConfig.maxHeight = '80vh';
        dialogConfig.data = this.returnHelpText(qId);
        const dialogRef = this.dialog.open(HelpTextComponent, dialogConfig);*/
    }

    returnHelpText(qId: number): string {
        let questionHelpText = this.lstQuestionHelpText.find((x) => x.QUESTIONS_ID == qId);

        if (questionHelpText) return questionHelpText?.HELP_TEXT;
        else return '';
    }

}
